module.exports = __webpack_public_path__ + "img/order.bc8d689b.svg";